import { SESSION_STORAGE_KEY } from "./user.constants";

const defaultLocation = sessionStorage.getItem(SESSION_STORAGE_KEY.DEFAULTMAP);
const defaultLevel = sessionStorage.getItem(SESSION_STORAGE_KEY.DEFAULTLEVEL);
export const APP_CONSTANTS = {
  DEFAULT_LOCATION_ID: defaultLocation ? defaultLocation : 1,
  DEFAULT_LEVEL: defaultLevel ? defaultLevel : 1,
};
